module.exports = __webpack_public_path__ + "img/loading.aee1181d.gif";